import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {TooltipService} from '../../../../shared/services/tooltip.service';
import {MessageInfo} from '../../../../shared/enums/error-messages/MessageInfo';
import {environment} from '../../../../../environments/environment';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {InvoiceLine} from "../../../../shared/models/account/invoice-line";
import {Invoice} from "../../../../shared/models/account/invoice";
import {RounderPipe} from "../../../../shared/utils/pipes";
import {ResponseSnackbarService} from '../../../../shared/services/response-snackbar.service';


interface InvoiceRefund {
  id: number;
  number: string;
  amount: number;
}
@Component({
  selector: 'app-amount-modal-component',
  templateUrl: './amount-modal.component.html',
  styleUrls: ['./amount-modal.component.scss']
})
export class AmountModalComponent implements OnInit {

  public formGroup: FormGroup;
  public amount: any;
  public paymentId: any;
  public maxAmount: any;
  payment;
  refundInvoices;
  invoices: InvoiceRefund[] = [];
  tooltipService: TooltipService;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  invalidDesc = MessageInfo.LIMIT_1_AND_2000;
  charChange: any;
  constructor(public dialogRef: MatDialogRef<AmountModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private restService: RestService,
              private rounderPipe: RounderPipe,
              private responseSnackBar: ResponseSnackbarService) {
    this.amount = data.amount;
    this.maxAmount = data.amount;
    this.paymentId = data.paymentId;
    this.getInvoicesRefunds();
    this.getPaymentData();
  }

  getPaymentData() {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.READ}/refund/${this.paymentId}`;
    this.restService
      .restRequest<any>(
        RequestMethod.GET,
        URL
      )
      .subscribe(response => {
        if (response.success) {
          this.payment = response.data;
          this.initForm(this.refundInvoices);
        }
      });
  }

  getInvoicesRefunds() {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.READ}/refund/invoices/${this.paymentId}`;
    this.restService
      .restRequest<any>(
        RequestMethod.GET,
        URL
      )
      .subscribe(response => {
        if (response.success) {
          this.refundInvoices = response.data;
          this.maxAmount = this.getAmountTotal(this.refundInvoices);
        }
      });
  }

  private initForm(items: any) {
    this.formGroup = new FormGroup({
      description: new FormControl('',
        [Validators.required, Validators.minLength(1),
          Validators.maxLength(1000)]),
      invoices: this.formBuilder.array(this.buildInvoiceLines(items))
     });
    this.formGroup.controls.invoices.valueChanges.subscribe(it => {
      this.amount = this.getAmountTotal(null);
    });
    this.tooltipService = new TooltipService(this.formGroup);
  }
  ngOnInit(): void {
  }
  noDelete(): void {
    this.dialogRef.close({delete: false});
  }

  delete(): void {
    if (this.amount <= 1) {
      this.formGroup.markAllAsTouched();
      this.responseSnackBar.onResponseMessage('Cannot refund any amount less than $1', GeneralConstant.SNACKBAR_ERROR_CLASS);
      return;
    }
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    this.amount = 0;
    const invoices: any[] = this.formGroup.get('invoices').value;
    for (const invoice of invoices) {
      this.amount = this.amount + invoice.amount;
      this.invoices.push({ id: invoice.id, number: invoice.number, amount : invoice.amount });
    }

    this.dialogRef.close({delete: true, refund: this.amount, description: this.charChange, invoices: this.invoices});
  }
  /**
   * Update Refund amount
   */
  updateAmountToRefund() {
    this.amount = this.formGroup.value.amount;
  }

  onTextareaValueChanged(newValue: string): void {
    this.charChange = newValue;
    this.formGroup.controls.description.setValue(this.charChange);
  }

  addInvoiceLine(): FormGroup {
    return this.formBuilder.group({
      id: new FormControl({value: 0, disabled: false}),
      number: new FormControl({value: '', disabled: false}),
      amount: new FormControl({value: '', disabled: false})
    });
  }
  private buildInvoiceLines(invoices: any) {
    const invoicesFormGroup: FormGroup[] = [];
    if (invoices) {
      invoices.forEach(ag => {
        const invoice = this.addInvoiceLine();
        invoice.get('id').setValue(ag?.invoiceId);
        invoice.get('number').setValue(ag?.number);
        invoice.get('amount').setValue(ag?.refundAmount);
        invoice.get('amount').setValidators([Validators.required, Validators.minLength(1),
          Validators.pattern(GeneralConstant.DECIMAL_NUMBER_REGEX_VALIDATOR),
          Validators.max(ag?.refundAmount), Validators.min(0)]);


        invoicesFormGroup.push(invoice);
      });
    }
    return invoicesFormGroup.length > 0 ? invoicesFormGroup : [this.addInvoiceLine()];
  }
  onChangePrice(event) {
    this.amount = this.getAmountTotal(null);
  }
  getAmountTotal(items: any): number{
    const invoices: any[] = items === null ? this.formGroup.get('invoices').value : items;
   // this.invoices = invoices;
    let amountTotal = 0;
    for (const invoice of invoices) {
      amountTotal += items === null ? invoice.amount : invoice.refundAmount;
    }
    return amountTotal;
  }

  refundAll(event) {

  }
}
